var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export class OutsideClickWrapper extends React.Component {
    constructor() {
        super(...arguments);
        this.clickCaptured = false;
        this.documentClick = () => {
            const { onClickOutside } = this.props;
            if (!this.clickCaptured && onClickOutside) {
                const mouseUpHandler = (event) => {
                    onClickOutside(event);
                    document.removeEventListener('mouseup', mouseUpHandler);
                    document.removeEventListener('touchend', mouseUpHandler);
                };
                document.addEventListener('mouseup', mouseUpHandler);
                document.addEventListener('touchend', mouseUpHandler);
            }
            this.clickCaptured = false;
        };
        this.innerClick = () => {
            this.clickCaptured = true;
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.documentClick);
        document.addEventListener('touchstart', this.documentClick);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.documentClick);
        document.removeEventListener('touchstart', this.documentClick);
    }
    render() {
        const _a = this.props, { className, onClick, onClickOutside } = _a, rest = __rest(_a, ["className", "onClick", "onClickOutside"]);
        const props = Object.assign(Object.assign({}, rest), { className,
            onClick, onMouseDown: this.innerClick, onTouchStart: this.innerClick });
        if (typeof this.props.children === 'function') {
            return this.props.children(props);
        }
        return React.createElement('div', props, this.props.children);
    }
}
